// assets/pillow-size-modal.js
// Size-picker modal for the SILON PILLOW product (no colour variations).
// Relies on `size-modal-factory.js` having been loaded already.

(function(){
  if (!window.SilonSizeModalFactory){
    console.error('[pillow-size-modal] Factory missing – ensure size-modal-factory.js is loaded first.');
    return;
  }

  // TODO: Replace the placeholder IDs with the real variant IDs of your pillow product.
  const productSizes = {
    'classic':      { id: '49738390307152',      surcharge: 0 }, // 40×60 cm
    'comfort':      { id: '49738390372688',      surcharge: 0 }, // 40×80 cm
    'comfortplus':  { id: '49738390339920',  surcharge: 0 }, // 50×70 cm
    'square':       { id: '51336253833552',       surcharge: 0 }, // 65×65 cm
    'royal-square': { id: '51336253866320',  surcharge: 5 }, // 80×80 cm
    'king/queen':   { id: '51336253899088',    surcharge: 5 }  // 65×100 cm
  };

  const OVERLAY_ID = 'size-modal';
  const HERO_URL = 'https://cdn.shopify.com/s/files/1/0869/6512/5456/files/Vogelperspektive_einer_Frau_mit_Kissen.png?v=1750968146';
  const MODAL_TITLE = 'Wähle die Grösse deines ArcticDream™ Kissens';

  // Override hero image + title once DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    const overlay = document.getElementById(OVERLAY_ID);
    if (!overlay) return;
    const hero = overlay.querySelector('.silon-modal__hero');
    if (hero) {
      hero.dataset.src = HERO_URL;
      hero.alt = 'Silon Kissen';
      hero.src = HERO_URL; // force load / swap immediately
    }
    const titleEl = overlay.querySelector('.silon-modal__title');
    if (titleEl) titleEl.textContent = MODAL_TITLE;
  });

  window.SilonPillowSizeModal = window.SilonSizeModalFactory({
    overlayId: OVERLAY_ID,
    productSizes,
    colorBased: false,
    defaultSize: 'comfortplus'
  });
})(); 